import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

export default class FruitAnimation {
  constructor({ section = document }) {
    this.section = section;
    this.init();
  }

  init() {
    //This function sets the start of the scroll animation to the current start of the window + 100vh. It can be called as a callback to another animation, which is perfect.
    const parallaxFruit = (fruit, section) => {
      const curTop = window.scrollY;
      let scrollTl = gsap.timeline({
        scrollTrigger: {
          trigger: "body",
          start: `${curTop} top`,
          end: `${curTop + window.innerHeight} top`,
          scrub: true,
        },
      });

      scrollTl.fromTo(
        fruit,
        {
          y: `0%`,
        },
        {
          y: `50%`,
        },
        0
      );
    };

    const fallInFruit = (fruit, section) => {
      return new Promise((resolve, reject) => {
        gsap.fromTo(
          fruit,
          {
            opacity: 0,
            y: `-100%`,
          },
          {
            delay: 0.5,
            opacity: 1,
            y: `0%`,
            duration: 1.2,
            onComplete: resolve,
          }
        );
      });
    };

    this.section.querySelectorAll(".fruit").forEach((fruit) => {
      const section = fruit.closest(".shopify-section");
      fallInFruit(fruit, section)
        .then(() => parallaxFruit(fruit, section));
    });
  }

};
